import Checkbox from "@mui/material/Checkbox";
import { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Avatar, Box, Button, Modal } from "@mui/material";
import { useFormik, isValid } from "formik";
import { useHistory } from "react-router-dom";
import { forgotPasswordSchema, formSchema } from "../Schemas/ChangePassword";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
const timezoneOptions = [
  {
    id: 1,
    label: "(UTC-12:00) International Date Line West",
    value: "(UTC-12:00) International Date Line West",
  },
  {
    id: 2,
    label: "(UTC-11:00) Coordinated Universal Time-11",
    value: "(UTC-11:00) Coordinated Universal Time-11",
  },
  { id: 3, label: "(UTC-10:00) Hawaii", value: "(UTC-10:00) Hawaii" },
  { id: 4, label: "(UTC-09:00) Alaska", value: "(UTC-09:00) Alaska" },
  {
    id: 5,
    label: "(UTC-08:00) Baja California",
    value: "(UTC-08:00) Baja California",
  },
  {
    id: 6,
    label: "(UTC-08:00) Pacific Time (US and Canada)",
    value: "(UTC-08:00) Pacific Time (US and Canada)",
  },
  {
    id: 7,
    label: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
    value: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
  },
  { id: 8, label: "(UTC-07:00) Arizona", value: "(UTC-07:00) Arizona" },
  {
    id: 9,
    label: "(UTC-07:00) Mountain Time (US and Canada)",
    value: "(UTC-07:00) Mountain Time (US and Canada)",
  },
  {
    id: 10,
    label: "(UTC-06:00) Central America",
    value: "(UTC-06:00) Central America",
  },
  {
    id: 11,
    label: "(UTC-06:00) Central Time (US and Canada)",
    value: "(UTC-06:00) Central Time (US and Canada)",
  },
  {
    id: 12,
    label: "(UTC-06:00) Saskatchewan",
    value: "(UTC-06:00) Saskatchewan",
  },
  {
    id: 13,
    label: "(UTC-06:00) Guadalajara, Mexico City, Monterey",
    value: "(UTC-06:00) Guadalajara, Mexico City, Monterey",
  },
  {
    id: 14,
    label: "(UTC-05:00) Bogota, Lima, Quito",
    value: "(UTC-05:00) Bogota, Lima, Quito",
  },
  {
    id: 15,
    label: "(UTC-05:00) Indiana (East)",
    value: "(UTC-05:00) Indiana (East)",
  },
  {
    id: 16,
    label: "(UTC-05:00) Eastern Time (US and Canada)",
    value: "(UTC-05:00) Eastern Time (US and Canada)",
  },
  { id: 17, label: "(UTC-04:30) Caracas", value: "(UTC-04:30) Caracas" },
  {
    id: 18,
    label: "(UTC-04:00) Atlantic Time (Canada)",
    value: "(UTC-04:00) Atlantic Time (Canada)",
  },
  { id: 19, label: "(UTC-04:00) Asuncion", value: "(UTC-04:00) Asuncion" },
  {
    id: 20,
    label: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
    value: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  { id: 21, label: "(UTC-04:00) Cuiaba", value: "(UTC-04:00) Cuiaba" },
  { id: 22, label: "(UTC-04:00) Santiago", value: "(UTC-04:00) Santiago" },
  {
    id: 23,
    label: "(UTC-03:30) Newfoundland",
    value: "(UTC-03:30) Newfoundland",
  },
  { id: 24, label: "(UTC-03:00) Brasilia", value: "(UTC-03:00) Brasilia" },
  { id: 25, label: "(UTC-03:00) Greenland", value: "(UTC-03:00) Greenland" },
  {
    id: 26,
    label: "(UTC-03:00) Cayenne, Fortaleza",
    value: "(UTC-03:00) Cayenne, Fortaleza",
  },
  {
    id: 27,
    label: "(UTC-03:00) Buenos Aires",
    value: "(UTC-03:00) Buenos Aires",
  },
  { id: 28, label: "(UTC-03:00) Montevideo", value: "(UTC-03:00) Montevideo" },
  {
    id: 29,
    label: "(UTC-02:00) Coordinated Universal Time-2",
    value: "(UTC-02:00) Coordinated Universal Time-2",
  },
  { id: 30, label: "(UTC-01:00) Cape Verde", value: "(UTC-01:00) Cape Verde" },
  { id: 31, label: "(UTC-01:00) Azores", value: "(UTC-01:00) Azores" },
  { id: 32, label: "(UTC+00:00) Casablanca", value: "(UTC+00:00) Casablanca" },
  {
    id: 33,
    label: "(UTC+00:00) Monrovia, Reykjavik",
    value: "(UTC+00:00) Monrovia, Reykjavik",
  },
  {
    id: 34,
    label: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
    value: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
  },
  {
    id: 35,
    label: "(UTC+00:00) Coordinated Universal Time",
    value: "(UTC+00:00) Coordinated Universal Time",
  },
  {
    id: 36,
    label: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    value: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  },
  {
    id: 37,
    label: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
    value: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
  },
  {
    id: 38,
    label: "(UTC+01:00) West Central Africa",
    value: "(UTC+01:00) West Central Africa",
  },
  {
    id: 39,
    label: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    value: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  },
  {
    id: 40,
    label: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    value: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  },
  { id: 41, label: "(UTC+01:00) Windhoek", value: "(UTC+01:00) Windhoek" },
  {
    id: 42,
    label: "(UTC+02:00) Athens, Bucharest, Istanbul",
    value: "(UTC+02:00) Athens, Bucharest, Istanbul",
  },
  {
    id: 43,
    label: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    value: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  },
  { id: 44, label: "(UTC+02:00) Cairo", value: "(UTC+02:00) Cairo" },
  { id: 45, label: "(UTC+02:00) Damascus", value: "(UTC+02:00) Damascus" },
  { id: 46, label: "(UTC+02:00) Amman", value: "(UTC+02:00) Amman" },
  {
    id: 47,
    label: "(UTC+02:00) Harare, Pretoria",
    value: "(UTC+02:00) Harare, Pretoria",
  },
  { id: 48, label: "(UTC+02:00) Jerusalem", value: "(UTC+02:00) Jerusalem" },
  { id: 49, label: "(UTC+02:00) Beirut", value: "(UTC+02:00) Beirut" },
  { id: 50, label: "(UTC+03:00) Baghdad", value: "(UTC+03:00) Baghdad" },
  { id: 51, label: "(UTC+03:00) Minsk", value: "(UTC+03:00) Minsk" },
  {
    id: 52,
    label: "(UTC+03:00) Kuwait, Riyadh",
    value: "(UTC+03:00) Kuwait, Riyadh",
  },
  { id: 53, label: "(UTC+03:00) Nairobi", value: "(UTC+03:00) Nairobi" },
  { id: 54, label: "(UTC+03:30) Tehran", value: "(UTC+03:30) Tehran" },
  {
    id: 55,
    label: "(UTC+04:00) Moscow, St. Petersburg, Volgograd",
    value: "(UTC+04:00) Moscow, St. Petersburg, Volgograd",
  },
  { id: 56, label: "(UTC+04:00) Tbilisi", value: "(UTC+04:00) Tbilisi" },
  { id: 57, label: "(UTC+04:00) Yerevan", value: "(UTC+04:00) Yerevan" },
  {
    id: 58,
    label: "(UTC+04:00) Abu Dhabi, Muscat",
    value: "(UTC+04:00) Abu Dhabi, Muscat",
  },
  { id: 59, label: "(UTC+04:00) Baku", value: "(UTC+04:00) Baku" },
  { id: 60, label: "(UTC+04:00) Port Louis", value: "(UTC+04:00) Port Louis" },
];

const currencyOptions = [
  { id: 1, value: "USD", label: "US Dollar $" },
  { id: 2, value: "EUR", label: "Euro €" },
  { id: 3, value: "JPY", label: "Japanese Yen ¥" },
  { id: 4, value: "GBP", label: "British Pound £" },
  { id: 5, value: "AUD", label: "Australian Dollar $" },
  { id: 6, value: "CAD", label: "Canadian Dollar $" },
  { id: 7, value: "CHF", label: "Swiss Franc Fr" },
  { id: 8, value: "CNY", label: "Chinese Yuan ¥" },
  { id: 9, value: "INR", label: "Indian Rupee ₹" },
  { id: 10, value: "SGD", label: "Singapore Dollar $" },
  { id: 11, value: "HKD", label: "Hong Kong Dollar $" },
  { id: 12, value: "NZD", label: "New Zealand Dollar $" },
  { id: 13, value: "SEK", label: "Swedish Krona kr" },
  { id: 14, value: "KRW", label: "South Korean Won ₩" },
  { id: 15, value: "ZAR", label: "South African Rand R" },
];

const locationOptions = [
  { id: 1, value: "NYC", label: "New York City" },
  { id: 2, value: "LA", label: "Los Angeles" },
  { id: 3, value: "CHI", label: "Chicago" },
  { id: 4, value: "HOU", label: "Houston" },
  { id: 5, value: "MIA", label: "Miami" },
  { id: 6, value: "SF", label: "San Francisco" },
  { id: 7, value: "DC", label: "Washington, D.C." },
  { id: 8, value: "BOS", label: "Boston" },
  { id: 9, value: "ATL", label: "Atlanta" },
  { id: 10, value: "DAL", label: "Dallas" },
  { id: 11, value: "PHI", label: "Philadelphia" },
  { id: 12, value: "DEN", label: "Denver" },
  { id: 13, value: "SEA", label: "Seattle" },
  { id: 14, value: "MSP", label: "Minneapolis" },
  { id: 15, value: "PHX", label: "Phoenix" },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
  display: "flex",
  flexDirection: "column",
};

const UpdateProfile = () => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [terms, setTerms] = useState(false);
  const [status, setStatus] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [currency, setCurrency] = useState("");
  const [location, setLocation] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const fullName = userDetails && userDetails?.details?.Name;
  const nameArray = fullName?.split(" ");
  const initials = nameArray?.map((word) => word.charAt(0));
  const initialsString = initials?.join("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [openForgotPasswordModal, setOpenForgotPasswordModal] = useState(false);
  const [wrongCurrentPassword, setWrongCurrentPassword] = useState(null);
  const history = useHistory();
  const handleChangePassword = (values, actions) => {
    let userData = {
      oldPassword: values.currentPassword,
      newPassword: values.newPassword,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/user/change-password/${
          userDetails && userDetails.details._id
        }`,
        userData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          userDetails.token = response.data.token;
          localStorage.setItem(
            "MailSenderuserDetails",
            JSON.stringify(userDetails)
          );
          setShowToast(true);
          actions.resetForm();
          setOpenPasswordModal(false);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          if (response.data.status === false) {
            setWrongCurrentPassword(response.data.message);
            setShowToast(true);
            toast.error(response.data.message, {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
          } else {
            setShowToast(true);
            actions.resetForm();
            setOpenPasswordModal(false);
            toast.error(response.data.message, {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
            if (response.data.tokenExpire) {
              localStorage.removeItem("MailSenderuserDetails");
              window.location.reload();
            }
          }
        }
      })
      .catch((err) => console.log("Error"));
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    handleReset,
    dirty,
    isValid,
  } = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: formSchema,
    onSubmit: handleChangePassword,
  });

  const handleForgotPassword = (values, actions) => {
    setShowToast(true);
    setTimeout(() => {
      actions.resetForm();
      setOpenForgotPasswordModal(false);
      toast.success(
        "password change link has to be sent to provide mail successfully,check provided mail",
        { autoClose: true, position: "top-right", duration: 3000 }
      );
    }, 2000);
  };

  const forgotFormik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: forgotPasswordSchema,
    onSubmit: handleForgotPassword,
  });
  const inputsArr = [
    {
      id: 1,
      label: "First name",
      type: "text",
      placeholder: "First Name",
      name: "firstName",
      inputType: "input",
      hint: "firstName",
    },
    {
      id: 2,
      label: "Last name",
      type: "text",
      placeholder: "Last Name",
      name: "lastName",
      inputType: "input",
      hint: "lastName",
    },
    {
      id: 3,
      label: "Email id",
      type: "email",
      placeholder: "Email",
      name: "email",
      inputType: "input",
      hint: "email",
    },
    // {
    //   id: 4,
    //   label: "Phone number",
    //   type: "number",
    //   placeholder: "Phone Number",
    //   name: "phoneNumber",
    //   inputType: "input",
    //   hint:"phoneNumber"
    // },
    // {
    //   id: 5,
    //   label: "Ip",
    //   type: "text",
    //   placeholder: "Ip address",
    //   name: "ip",
    //   inputType: "input",
    //   value:''
    // },
    {
      id: 6,
      label: "Currency",
      type: "text",
      placeholder: "Enter currency",
      name: "currency",
      inputType: "Menu",
    },
    {
      id: 7,
      label: "Location",
      type: "text",
      placeholder: "Location",
      name: "location",
      inputType: "Menu",
    },
    {
      id: 8,
      label: "Timezone",
      type: "text",
      placeholder: "Timezone",
      name: "timezone",
      inputType: "Menu",
    },
  ];

  const [formData, setFormData] = useState({
    firstName: userDetails.details.FirstName,
    lastName: userDetails.details.LastName,
    email: userDetails.details.Email,
    phoneNumber: userDetails.details.Phone,
    ip: "",
  });
  const handleOnchange = (e) => {
    if (e.target.name === "phoneNumber") {
      if (e.target.value.length < 11) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      }
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  function getUserInfo() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/get-user-info-by-id/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        formData.firstName = response.data.details.FirstName;
        formData.lastName = response.data.details.LastName;
        formData.phoneNumber = response.data.details.Phone;
        formData.email = response.data.details.Email;
        if (response.data.details.TimeZone !== undefined) {
          setTimeZone(response.data.details.TimeZone);
        }
        if (response.data.details.Currency !== undefined) {
          setCurrency(response.data.details.Currency);
        }
        if (response.data.details.Location !== undefined) {
          setLocation(response.data.details.Location);
        }
        //  console.log("fjjffjfrjjrrj",formData)
        setFormData([...formData]);
      })
      .catch((err) => console.log("Error"));
  }
  const handleFormSubmit = (event) => {
    event.preventDefault();
    const payload = {
      ...formData,
      currency,
      location,
      timeZone,
    };
    let userData = {
      firstName: payload.firstName,
      lastName: payload.lastName,
      phone: payload.phoneNumber,
      timeZone: payload.timeZone,
      location: payload.location,
      currency: payload.currency,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/user/update-user-info/${
          userDetails && userDetails.details._id
        }`,
        userData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setShowToast(true);
          toast.success(response.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          getUserInfo();
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
    console.log(
      "form submitting successfully you can tes yourself=======>",
      payload
    );
    // setFormData({})
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    // You can now handle the selected file, for example, by uploading it to a server or displaying it.
    console.log("Selected file:", file);
    setProfilePhoto(file);
  };

  const handleCurrency = (e) => {
    setCurrency(e.target.value);
  };

  const handleLocation = (e) => {
    setLocation(e.target.value);
  };

  const handleTimeZone = (e) => {
    setTimeZone(e.target.value);
  };

  const SelectMenu = (props) => {
    const MenuData =
      props === "currency"
        ? currencyOptions
        : props === "location"
        ? locationOptions
        : timezoneOptions;
    const placeHolder =
      props === "currency"
        ? "Select your currency"
        : props === "location"
        ? "Select your location"
        : "Select your time zone";
    const selectEvents =
      props === "currency"
        ? handleCurrency
        : props === "location"
        ? handleLocation
        : handleTimeZone;
    const finalValue =
      props === "currency"
        ? currency
        : props === "location"
        ? location
        : timeZone;

    return (
      <div>
        <FormControl size="medium" sx={{ width: "100%" }}>
          <Select
            displayEmpty
            variant="standard"
            value={finalValue}
            disableUnderline
            onChange={selectEvents}
            sx={{
              outline: "none",
              backgroundColor: "#FAFAFA",
              padding: "6px 0px 6px 6px",
              borderRadius: "4px",
              border: "1px solid #1C485F",
              color: "#8B8B8B",
            }}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return (
                  <em
                    style={{
                      fontStyle: "normal",
                      fontSize: "14px",
                      color: "#888888",
                    }}
                  >
                    {placeHolder}
                  </em>
                );
              }
              return selected;
            }}
            inputProps={{ "aria-label": "Without label" }}
          >
            {MenuData.map((name, index) => (
              <MenuItem
                disableRipple
                disableTouchRipple
                key={name.id}
                value={name.value}
                sx={{
                  borderBottom: MenuData.length !== name.id && "1px solid #DDD",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontWeight: 400,
                  fontStyle: "normal",
                  color: "#838383",
                }}
              >
                {name.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  };
  function deleteUser() {
    setStatus(true);
    let userData1 = {
      reason: "",
    };
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      body: JSON.stringify(userData1),
      url: `${BaseUrl.baseurl}/email-marketing/user/delete-user-info/${
        userDetails && userDetails.details._id
      }`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          localStorage.removeItem("MailSenderuserDetails");
          window.location.reload();
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const deleteModal = () => {
    return (
      <div>
        <Modal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <svg
              style={{ alignSelf: "center", marginBottom: "10px" }}
              xmlns="http://www.w3.org/2000/svg"
              width="95"
              height="94"
              viewBox="0 0 95 94"
              fill="none"
            >
              <path
                d="M47.5005 35.2506V50.9172M17.6512 59.5331C14.0893 65.7026 12.3088 68.7885 12.5748 71.3197C12.8069 73.5276 13.9657 75.5335 15.7617 76.8384C17.8201 78.3339 21.3799 78.3339 28.4989 78.3339H66.5021C73.6211 78.3339 77.1803 78.3339 79.2387 76.8384C81.0348 75.5335 82.1941 73.5276 82.4261 71.3197C82.6922 68.7885 80.9122 65.7026 77.3503 59.5331L58.3555 26.6331C54.7935 20.4637 53.0118 17.3794 50.6866 16.3442C48.6585 15.4412 46.3412 15.4412 44.3131 16.3442C41.9889 17.379 40.2082 20.4632 36.6492 26.6276L17.6512 59.5331ZM47.6994 62.6672V63.0589L47.3054 63.0596V62.6672H47.6994Z"
                stroke="#FFCB2F"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <h1
              style={{
                lineHeight: "12px",
                color: "#4b4b4b",
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: 700,
                fontStyle: "normal",
              }}
            >
              Delete account?
            </h1>
            <p
              style={{
                padding: "16px 0px",
                color: "#868686",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontWeight: 400,
                fontStyle: "normal",
              }}
            >
              You will not be able to access your account and all your saved
              data will be lost.
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "12px",
                gap: "8px",
              }}
            >
              <Button
                disableRipple
                disableElevation
                onClick={() => setOpenDeleteModal(false)}
                sx={{
                  textTransform: "none",
                  border: "1px solid #1C485F",
                  outline: "none !important",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  "&:hover": {
                    background: "transparent !important",
                  },
                }}
              >
                Cancel
              </Button>

              <Button
                onClick={() => {
                  deleteUser();
                }}
                disableRipple
                disableElevation
                style={{
                  textTransform: "none",
                  background: "#FF3301",
                  outline: "none",
                  color: "#fff",
                  padding: "10px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {status ? (
                  <CircularProgress
                    size={15}
                    style={{
                      color: "white",
                    }}
                  />
                ) : (
                  "Yes,Delete it"
                )}
              </Button>
            </div>
            <Button
              disableRipple
              disableElevation
              onClick={() => setOpenDeleteModal(false)}
              sx={{
                textTransform: "none",
                outline: "none !important",
                padding: "9px 16px",
                fontSize: "14px",
                fontWeight: "400",
                position: "absolute",
                top: 0,
                right: 0,
                "&:hover": {
                  background: "transparent !important",
                },
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.16992 14.8299L14.8299 9.16992"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.8299 14.8299L9.16992 9.16992"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Button>
          </Box>
        </Modal>
      </div>
    );
  };

  const hasUpperCase = /[A-Z]/.test(values.newPassword);
  const hasLowerCase = /[a-z]/.test(values.newPassword);
  const hasNumber = /\d/.test(values.newPassword);
  const specialCharacterRegex = /[!@#\$%\^&\*]/;
  const containsSpecialCharacter = specialCharacterRegex.test(
    values.newPassword
  );
  const initialSvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.99935 1.33366C4.33268 1.33366 1.33268 4.33366 1.33268 8.00033C1.33268 11.667 4.33268 14.667 7.99935 14.667C11.666 14.667 14.666 11.667 14.666 8.00033C14.666 4.33366 11.666 1.33366 7.99935 1.33366Z"
        stroke="#868686"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 10.667V7.33366"
        stroke="#868686"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.00391 5.33301H7.99792"
        stroke="#868686"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  const activeSvg = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99935 1.33366C4.33268 1.33366 1.33268 4.33366 1.33268 8.00033C1.33268 11.667 4.33268 14.667 7.99935 14.667C11.666 14.667 14.666 11.667 14.666 8.00033C14.666 4.33366 11.666 1.33366 7.99935 1.33366Z"
        stroke="#4BC25F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.5 8L6.5 10.5L11.5 6"
        stroke="#4BC25F"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  const errorSvg = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49996 1.33317C4.83329 1.33317 1.83329 4.33317 1.83329 7.99984C1.83329 11.6665 4.83329 14.6665 8.49996 14.6665C12.1666 14.6665 15.1666 11.6665 15.1666 7.99984C15.1666 4.33317 12.1666 1.33317 8.49996 1.33317Z"
        stroke="#FF3434"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.5 10.7321L8.4641 7.86603L11.4282 5"
        stroke="#FF3434"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.76795 5L8.63397 7.9641L11.5 10.9282"
        stroke="#FF3434"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  const passwordChangeModal = () => {
    return (
      <Modal
        open={openPasswordModal}
        onClose={() => {
          setOpenPasswordModal(false);
          setWrongCurrentPassword(null);
          if (Object.values(errors).length !== 0) {
            handleReset();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form onSubmit={handleSubmit}>
            <h1
              style={{
                lineHeight: "12px",
                color: "#4b4b4b",
                fontFamily: "Source Sans 3",
                fontSize: "18px",
                fontWeight: 700,
                fontStyle: "normal",
              }}
            >
              Change password
            </h1>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                margin: "12px 0px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  position: "relative",
                }}
              >
                <label
                  htmlFor="currentPassword"
                  style={{
                    color: "#393939",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  Current password
                </label>
                <div
                  style={{
                    border: `1px solid ${
                      wrongCurrentPassword
                        ? "red"
                        : errors.currentPassword && touched.currentPassword
                        ? "red"
                        : "#1C485F"
                    }`,
                    display: "flex",
                    gap: "6px",
                    backgroundColor: "#FAFAFA",
                    borderRadius: "4px",
                    padding: "0px 12px 0px 0px",
                  }}
                >
                  <input
                    autoComplete="off"
                    onBlur={handleBlur}
                    placeholder="Enter your current password"
                    type={`${showCurrentPassword ? "text" : "password"}`}
                    onChange={handleChange}
                    value={values.currentPassword}
                    id="currentPassword"
                    style={{
                      padding: "12px 4px 12px 12px",
                      backgroundColor: "#FAFAFA",
                      borderRadius: "4px",
                      outline: "none",
                      flexGrow: 1,
                    }}
                  />
                  <button
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                    type="button"
                    style={{ outline: "none" }}
                  >
                    {showCurrentPassword ? (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="vuesax/linear/eye">
                          <g id="eye">
                            <path
                              id="Vector"
                              d="M12.9833 9.99993C12.9833 11.6499 11.6499 12.9833 9.99993 12.9833C8.34993 12.9833 7.0166 11.6499 7.0166 9.99993C7.0166 8.34993 8.34993 7.0166 9.99993 7.0166C11.6499 7.0166 12.9833 8.34993 12.9833 9.99993Z"
                              stroke="#868686"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              id="Vector_2"
                              d="M9.99987 16.8918C12.9415 16.8918 15.6832 15.1584 17.5915 12.1584C18.3415 10.9834 18.3415 9.00843 17.5915 7.83343C15.6832 4.83343 12.9415 3.1001 9.99987 3.1001C7.0582 3.1001 4.31654 4.83343 2.4082 7.83343C1.6582 9.00843 1.6582 10.9834 2.4082 12.1584C4.31654 15.1584 7.0582 16.8918 9.99987 16.8918Z"
                              stroke="#868686"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M12.1092 7.8916L7.89258 12.1083C7.35091 11.5666 7.01758 10.8249 7.01758 9.99993C7.01758 8.34993 8.35091 7.0166 10.0009 7.0166C10.8259 7.0166 11.5676 7.34994 12.1092 7.8916Z"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.8499 4.8084C13.3915 3.7084 11.7249 3.1084 9.99987 3.1084C7.0582 3.1084 4.31654 4.84173 2.4082 7.84173C1.6582 9.01673 1.6582 10.9917 2.4082 12.1667C3.06654 13.2001 3.8332 14.0917 4.66654 14.8084"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.01758 16.2751C7.96758 16.6751 8.97591 16.8917 10.0009 16.8917C12.9426 16.8917 15.6842 15.1584 17.5926 12.1584C18.3426 10.9834 18.3426 9.0084 17.5926 7.8334C17.3176 7.40006 17.0176 6.99173 16.7092 6.6084"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.9242 10.583C12.7076 11.758 11.7492 12.7163 10.5742 12.933"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.89102 12.1084L1.66602 18.3334"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.3324 1.66699L12.1074 7.89199"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                {wrongCurrentPassword !== null && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    {wrongCurrentPassword}
                  </p>
                )}
                {errors.currentPassword && touched.currentPassword && (
                  <p style={{ color: "red", marginTop: "0px" }}>
                    {errors.currentPassword}
                  </p>
                )}
                <p
                  onClick={() => {
                    setOpenForgotPasswordModal(true);
                    setOpenPasswordModal(false);
                    setWrongCurrentPassword(null);
                    if (Object.values(errors).length !== 0) {
                      handleReset();
                    }
                  }}
                  style={{
                    color: "#3471B8",
                    marginTop: "0px",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontStyle: "normal",
                    alignSelf: "flex-end",
                    cursor: "pointer",
                  }}
                >
                  Forgot password?
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  position: "relative",
                }}
              >
                <label
                  htmlFor="newPassword"
                  style={{
                    color: "#393939",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  New password
                </label>
                <div
                  style={{
                    border: `1px solid ${
                      errors.newPassword && touched.newPassword
                        ? "red"
                        : "#1C485F"
                    }`,
                    display: "flex",
                    gap: "6px",
                    backgroundColor: "#FAFAFA",
                    borderRadius: "4px",
                    padding: "0px 12px 0px 0px",
                    marginBottom: "3px",
                  }}
                >
                  <input
                    autoComplete="off"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter your new password"
                    type={`${showNewPassword ? "text" : "password"}`}
                    id="newPassword"
                    value={values.newPassword}
                    style={{
                      padding: "12px 4px 12px 12px",
                      backgroundColor: "#FAFAFA",
                      borderRadius: "4px",
                      outline: "none",
                      flexGrow: 1,
                    }}
                  />
                  <button
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    type="button"
                    style={{ outline: "none" }}
                  >
                    {showNewPassword ? (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="vuesax/linear/eye">
                          <g id="eye">
                            <path
                              id="Vector"
                              d="M12.9833 9.99993C12.9833 11.6499 11.6499 12.9833 9.99993 12.9833C8.34993 12.9833 7.0166 11.6499 7.0166 9.99993C7.0166 8.34993 8.34993 7.0166 9.99993 7.0166C11.6499 7.0166 12.9833 8.34993 12.9833 9.99993Z"
                              stroke="#868686"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              id="Vector_2"
                              d="M9.99987 16.8918C12.9415 16.8918 15.6832 15.1584 17.5915 12.1584C18.3415 10.9834 18.3415 9.00843 17.5915 7.83343C15.6832 4.83343 12.9415 3.1001 9.99987 3.1001C7.0582 3.1001 4.31654 4.83343 2.4082 7.83343C1.6582 9.00843 1.6582 10.9834 2.4082 12.1584C4.31654 15.1584 7.0582 16.8918 9.99987 16.8918Z"
                              stroke="#868686"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M12.1092 7.8916L7.89258 12.1083C7.35091 11.5666 7.01758 10.8249 7.01758 9.99993C7.01758 8.34993 8.35091 7.0166 10.0009 7.0166C10.8259 7.0166 11.5676 7.34994 12.1092 7.8916Z"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.8499 4.8084C13.3915 3.7084 11.7249 3.1084 9.99987 3.1084C7.0582 3.1084 4.31654 4.84173 2.4082 7.84173C1.6582 9.01673 1.6582 10.9917 2.4082 12.1667C3.06654 13.2001 3.8332 14.0917 4.66654 14.8084"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.01758 16.2751C7.96758 16.6751 8.97591 16.8917 10.0009 16.8917C12.9426 16.8917 15.6842 15.1584 17.5926 12.1584C18.3426 10.9834 18.3426 9.0084 17.5926 7.8334C17.3176 7.40006 17.0176 6.99173 16.7092 6.6084"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.9242 10.583C12.7076 11.758 11.7492 12.7163 10.5742 12.933"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.89102 12.1084L1.66602 18.3334"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.3324 1.66699L12.1074 7.89199"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                <span
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    color: "#5E5E5E",
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  {values.newPassword.length >= 8 &&
                  hasUpperCase &&
                  hasLowerCase
                    ? activeSvg
                    : values.newPassword.length === 0
                    ? initialSvg
                    : errorSvg}
                  Include both lower and upper case characters , at least 8
                  characters
                </span>
                <span
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    color: "#5E5E5E",
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  {hasNumber && (hasUpperCase || hasLowerCase)
                    ? activeSvg
                    : values.newPassword.length === 0
                    ? initialSvg
                    : errorSvg}
                  Contains a number & Contains a letter
                </span>
                <span
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    color: "#5E5E5E",
                    fontFamily: "Source Sans 3",
                    fontSize: "12px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  {containsSpecialCharacter
                    ? activeSvg
                    : values.newPassword.length === 0
                    ? initialSvg
                    : errorSvg}
                  {`Contains a special character[!,@,#,$,%,^,&,*`}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                  position: "relative",
                }}
              >
                <label
                  style={{
                    color: "#393939",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                  htmlFor="confirmPassword"
                >
                  Confirm new password
                </label>
                <div
                  style={{
                    border: `1px solid ${
                      errors.confirmPassword && touched.confirmPassword
                        ? "red"
                        : "#1C485F"
                    }`,
                    display: "flex",
                    gap: "6px",
                    backgroundColor: "#FAFAFA",
                    borderRadius: "4px",
                    padding: "0px 12px 0px 0px",
                  }}
                >
                  <input
                    autoComplete="off"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter your confirm password"
                    type={`${showConfirmPassword ? "text" : "password"}`}
                    id="confirmPassword"
                    value={values.confirmPassword}
                    style={{
                      padding: "12px 4px 12px 12px",
                      backgroundColor: "#FAFAFA",
                      borderRadius: "4px",
                      outline: "none",
                      flexGrow: 1,
                    }}
                  />
                  <button
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    type="button"
                    style={{ outline: "none" }}
                  >
                    {showConfirmPassword ? (
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="vuesax/linear/eye">
                          <g id="eye">
                            <path
                              id="Vector"
                              d="M12.9833 9.99993C12.9833 11.6499 11.6499 12.9833 9.99993 12.9833C8.34993 12.9833 7.0166 11.6499 7.0166 9.99993C7.0166 8.34993 8.34993 7.0166 9.99993 7.0166C11.6499 7.0166 12.9833 8.34993 12.9833 9.99993Z"
                              stroke="#868686"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              id="Vector_2"
                              d="M9.99987 16.8918C12.9415 16.8918 15.6832 15.1584 17.5915 12.1584C18.3415 10.9834 18.3415 9.00843 17.5915 7.83343C15.6832 4.83343 12.9415 3.1001 9.99987 3.1001C7.0582 3.1001 4.31654 4.83343 2.4082 7.83343C1.6582 9.00843 1.6582 10.9834 2.4082 12.1584C4.31654 15.1584 7.0582 16.8918 9.99987 16.8918Z"
                              stroke="#868686"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M12.1092 7.8916L7.89258 12.1083C7.35091 11.5666 7.01758 10.8249 7.01758 9.99993C7.01758 8.34993 8.35091 7.0166 10.0009 7.0166C10.8259 7.0166 11.5676 7.34994 12.1092 7.8916Z"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.8499 4.8084C13.3915 3.7084 11.7249 3.1084 9.99987 3.1084C7.0582 3.1084 4.31654 4.84173 2.4082 7.84173C1.6582 9.01673 1.6582 10.9917 2.4082 12.1667C3.06654 13.2001 3.8332 14.0917 4.66654 14.8084"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.01758 16.2751C7.96758 16.6751 8.97591 16.8917 10.0009 16.8917C12.9426 16.8917 15.6842 15.1584 17.5926 12.1584C18.3426 10.9834 18.3426 9.0084 17.5926 7.8334C17.3176 7.40006 17.0176 6.99173 16.7092 6.6084"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.9242 10.583C12.7076 11.758 11.7492 12.7163 10.5742 12.933"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.89102 12.1084L1.66602 18.3334"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.3324 1.66699L12.1074 7.89199"
                          stroke="#868686"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                {errors.confirmPassword && touched.confirmPassword && (
                  <p style={{ color: "red" }}>{errors.confirmPassword}</p>
                )}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "12px",
                gap: "12px",
              }}
            >
              <Button
                disableRipple
                disableElevation
                onClick={() => {
                  handleReset();
                  setOpenPasswordModal(false);
                  setShowCurrentPassword(false);
                  setShowConfirmPassword(false);
                  setShowNewPassword(false);
                  setWrongCurrentPassword(null);
                  handleReset();
                }}
                sx={{
                  textTransform: "none",
                  border: "1px solid #1C485F",
                  outline: "none !important",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  "&:hover": {
                    background: "transparent !important",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                disableRipple
                disableElevation
                style={{
                  textTransform: "none",
                  outline: "none",
                  color: "#fff",
                  backgroundColor: "#FF3301",
                  padding: "10px 22px",
                  fontSize: "14px",
                  fontWeight: "400",
                  // opacity: dirty && isValid ? 1 : 0.6
                }}
              >
                Save
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
    );
  };

  const forgotPasswordModal = () => {
    return (
      <Modal
        open={openForgotPasswordModal}
        onClose={() => setOpenForgotPasswordModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form
            onSubmit={forgotFormik.handleSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "25px" }}
          >
            <p
              style={{
                color: "#4b4b4b",
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: 700,
                fontStyle: "normal",
                textAlign: "center",
              }}
            >
              You will be logged out and taken to login screen from there you
              can navigate to forgot password page
            </p>
            <div
              style={{ display: "flex", gap: "20px", justifyContent: "center" }}
            >
              <button
                onClick={() => setOpenForgotPasswordModal(false)}
                style={{
                  border: "1px solid #1C485F",
                  outline: "none",
                  backgroundColor: "transparent",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "6px",
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  localStorage.removeItem("MailSenderuserDetails");
                  window.location.reload();
                  history.push("/ForgotPassword");
                }}
                className="bg-primary"
                style={{
                  outline: "none",
                  color: "#FFF",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "6px",
                }}
              >
                Continue
              </button>
            </div>
          </form>
        </Box>
      </Modal>
    );
  };

  return (
    <div style={{ backgroundColor: "#fff", padding: "12px 10px 12px 14px" }}>
      <form style={{ padding: "0px 2px 0px 0px" }} onSubmit={handleFormSubmit}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "16px",
          }}
        >
          {inputsArr.map((data, idx) => (
            <div
              key={data.id}
              style={{ display: "flex", flexDirection: "column", gap: "6px" }}
            >
              {data.inputType === "input" && (
                <label htmlFor={data.id}>{data.label}</label>
              )}
              {data.inputType === "input" ? (
                <input
                  value={formData[data.hint]}
                  type={data.type}
                  onChange={handleOnchange}
                  name={data.name}
                  style={{
                    pointerEvents: idx === 2 && "none",
                    backgroundColor: "#FAFAFA",
                    border: "1px solid #1C485F",
                    padding: "13px 10px",
                    outline: "none",
                    borderRadius: "4px",
                  }}
                  placeholder={data.placeholder}
                />
              ) : (
                <>{/* {SelectMenu(data.name)} */}</>
              )}
            </div>
          ))}
        </div>
        <button
          type="submit"
          className="bg-primary"
          style={{
            color: "#fff",
            borderRadius: "4px",
            padding: "7px 12px",
            outline: "none",
          }}
        >
          Save
        </button>
      </form>
      <div style={{ marginTop: "35px" }}>
        <p
          style={{
            color: "#393939",
            fontFamily: "Source Sans 3",
            fontSize: "15px",
            fontStyle: "normal",
            fontWeight: 700,
          }}
        >
          Password
        </p>
        {/* <p style={{ color: "#393939", fontFamily: "Source Sans 3", fontSize: "12px", fontStyle: "normal"}}>Last password change was on 27 Oct 2023</p> */}
        <button
          onClick={() => setOpenPasswordModal(true)}
          type="button"
          className="bg-primary"
          style={{
            color: "#fff",
            borderRadius: "4px",
            padding: "8px 12px",
            outline: "none",
            display: "flex",
            gap: "6px",
            alignItems: "center",
            marginTop: "12px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M5 8.33366V6.66699C5 3.90866 5.83333 1.66699 10 1.66699C14.1667 1.66699 15 3.90866 15 6.66699V8.33366"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.99935 15.4167C11.1499 15.4167 12.0827 14.4839 12.0827 13.3333C12.0827 12.1827 11.1499 11.25 9.99935 11.25C8.84876 11.25 7.91602 12.1827 7.91602 13.3333C7.91602 14.4839 8.84876 15.4167 9.99935 15.4167Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.166 18.333H5.83268C2.49935 18.333 1.66602 17.4997 1.66602 14.1663V12.4997C1.66602 9.16634 2.49935 8.33301 5.83268 8.33301H14.166C17.4993 8.33301 18.3327 9.16634 18.3327 12.4997V14.1663C18.3327 17.4997 17.4993 18.333 14.166 18.333Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Change Password
        </button>
      </div>
      <div style={{ marginTop: "35px" }}>
        <p
          style={{
            color: "#393939",
            fontFamily: "Source Sans 3",
            fontSize: "15px",
            fontStyle: "normal",
            fontWeight: 700,
          }}
        >
          Delete account
        </p>
        <p
          style={{
            color: "#868686",
            fontFamily: "Source Sans 3",
            fontSize: "13px",
            fontStyle: "normal",
          }}
        >
          If you delete your account, all the collected and personal data will
          be removed. Learn more about how{" "}
          <span
            style={{
              color: "#1C485F",
              ontFamily: "Source Sans 3",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 400,
            }}
          >
            coldsender.com
          </span>{" "}
          handles your data after account deletion from{" "}
          <a
            href="https://coldsender.com/terms-and-conditions/"
            target="_blank"
            style={{
              color: "#1C485F",
              ontFamily: "Source Sans 3",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 400,
              textDecoration: "underline",
            }}
          >
            Terms and Conditions
          </a>{" "}
          and{" "}
          <a
            href="https://coldsender.com/privacy-policy/"
            target="_blank"
            style={{
              color: "#1C485F",
              ontFamily: "Source Sans 3",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 400,
              textDecoration: "underline",
            }}
          >
            Privacy Policy
          </a>
          .
        </p>

        <button
          onClick={() => setOpenDeleteModal(true)}
          type="button"
          className="bg-primary"
          style={{
            color: "#FFF",
            borderRadius: "4px",
            padding: "8px 12px",
            outline: "none",
            display: "flex",
            gap: "6px",
            alignItems: "center",
            marginTop: "12px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M17.5 4.98307C14.725 4.70807 11.9333 4.56641 9.15 4.56641C7.5 4.56641 5.85 4.64974 4.2 4.81641L2.5 4.98307"
              stroke="#FFF"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.08398 4.14199L7.26732 3.05033C7.40065 2.25866 7.50065 1.66699 8.90898 1.66699H11.0923C12.5007 1.66699 12.609 2.29199 12.734 3.05866L12.9173 4.14199"
              stroke="#FFF"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.7077 7.61621L15.166 16.0079C15.0743 17.3162 14.9993 18.3329 12.6743 18.3329H7.32435C4.99935 18.3329 4.92435 17.3162 4.83268 16.0079L4.29102 7.61621"
              stroke="#FFF"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.60742 13.75H11.3824"
              stroke="#FFF"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.91602 10.417H12.0827"
              stroke="#FFF"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Delete my account
        </button>
      </div>
      {showToast && <ToastContainer />}
      {openDeleteModal && deleteModal()}
      {openPasswordModal && passwordChangeModal()}
      {openForgotPasswordModal && forgotPasswordModal()}
    </div>
  );
};

export default UpdateProfile;
